import { lazy } from "react";
import type { RouteObject } from "react-router";
import { ProtectedRoute } from "@/src/auth/components/protected-route";
import { STAFF_OR_ABOVE_ROLES } from "@/src/students/constants/students.constants";
import { STUDENTS_ROUTES } from "@/src/students/constants/students-routes.constants";

const StudentsListPage = lazy(() => import("@/src/students/pages/students-list.page"));
const StudentDetailPage = lazy(() => import("@/src/students/pages/student-detail.page"));

/**
 * Students management routes. Mounted under `AuthedLayout` in the root
 * router; everything inside requires `staff | admin | super_admin`.
 */
export const studentsRoutes: RouteObject[] = [
	{
		element: <ProtectedRoute requiredRole={[...STAFF_OR_ABOVE_ROLES]} />,
		children: [
			{ path: STUDENTS_ROUTES.students, element: <StudentsListPage /> },
			{ path: STUDENTS_ROUTES.detailPattern, element: <StudentDetailPage /> },
		],
	},
];
